// shared-lib/cabinet-runs/doubleBowlUnit.js
//
// TWO BOWLS UNDER A CABINET LINE: one double-bowl unit, or two single sink
// bases?
//
// The user's call, 2026-10-21 — "(a) is fine for now, but we may want to
// change this later". (a) is the line's double-bowl unit (Venus's
// VSD60DOUBLE) wherever both bowls fit inside it, and one single sink base
// per bowl everywhere else. Set this to false and every two-bowl vanity in a
// line is built as two single sink bases; nothing else changes.
//
// It lives in a file of its own so that it is the WHOLE decision, in one
// place: `vanitySinkBay.js` reads it and nothing else decides it.

module.exports = { DOUBLE_BOWL_UNIT_WHEN_BOTH_FIT: true };
